import { render, staticRenderFns } from "./milkYieldOfCowsOnDate.vue?vue&type=template&id=11998b2b&scoped=true&"
import script from "./milkYieldOfCowsOnDate.vue?vue&type=script&lang=js&"
export * from "./milkYieldOfCowsOnDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11998b2b",
  null
  
)

export default component.exports